import { useNavigate } from 'react-router-dom'
import ForwardIcon from '../Icons/ForwardIcon'
import QrTicketIcon from '../Icons/QrTicketIcon'

const QrId = ({ handler = null, id = '', noHandler = false }) => {
  const navigate = useNavigate()
  const handleQrTicket = () => {
    navigate(id)
  }

  return (
    <div className="qr_id_component" onClick={noHandler ? null : handler || handleQrTicket}>
      <QrTicketIcon />
      <span className="title">QR-квиток</span>
      <span className="id">{id}</span>
      {!noHandler && <ForwardIcon />}
    </div>
  )
}

export default QrId
